import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import axios from 'redaxios'
import { useIdentity } from '../../../hooks/useIdentity'
import { AppStats } from '../utilities/customAppHelpers'

export const useCustomAppPage = (appId: string | null, environmentId: string) => {
  const { identity, hasPermission } = useIdentity()
  const hasAppAccess = hasPermission({ resource: identity.account, permissionKey: 'app:read' })
  const {
    data: appStats,
    isError: isGetAppStatsError,
    isLoading: isGetAppStatsLoading,
  } = useQuery({
    enabled: hasAppAccess && !!appId && appId.trim() !== '',
    queryKey: ['getAppStats', appId, environmentId],
    queryFn: () => {
      if (!appId) {
        throw new Error('AppId is required for stats query')
      }
      return axios.get(
        `${window.flatfile.configService.get('VITE_BASE_API_URL')}/v1/internal/apps/${appId}/stats?environmentId=${environmentId}`
      )
    },
  })

  const statsData: AppStats = useMemo(() => {
    if (!appStats?.data.data) {
      return []
    }
    return appStats.data.data
  }, [appStats?.data.data])

  if (!hasAppAccess) {
    return {
      statsData: null,
      isGetAppStatsError: false,
      isGetAppStatsLoading: false,
    }
  }

  return {
    statsData,
    isGetAppStatsError,
    isGetAppStatsLoading,
  }
}
